import type {ActionSpec, ActionStruct} from '@cohort/shared/schema/apps/app';
import z from 'zod';

export const DiscordGuildMembershipSchema = z.object({
  roles: z.array(z.string()),
  joined_at: z.string(),
});
export type DiscordGuildMembership = z.infer<typeof DiscordGuildMembershipSchema>;

export const GetMemberInputSchema = z.object({userId: z.string()});
export type GetMemberInput = z.infer<typeof GetMemberInputSchema>;

export const GetMemberOutputSchema = z.object({
  membership: DiscordGuildMembershipSchema.nullable(),
});
export type GetMemberOutput = z.infer<typeof GetMemberOutputSchema>;

export type GetMemberActionStruct = ActionStruct<'get-member', GetMemberInput, GetMemberOutput>;
export const GetMemberActionSpec: ActionSpec<GetMemberActionStruct> = {
  id: 'get-member',
  inputSchema: GetMemberInputSchema,
  outputSchema: GetMemberOutputSchema,
};
